import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Pranav Gupta.</p>
        <p>Please email for resume.</p>
        <p>
          Website made with code.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
